(() => {
  const configElement = document.getElementById('NeonHubCurrencyConfig');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    return;
  }

  const sourceCurrency = String(config.baseCurrency || 'AED').toUpperCase();
  if (sourceCurrency === 'AED') return;

  const locale = config.locale || document.documentElement.lang || 'en-AE';
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: sourceCurrency,
    currencyDisplay: 'narrowSymbol',
  });
  const format = (cents) => formatter.format(Number(cents) / 100);

  const applyNativeAmounts = (root) => {
    const elements = root?.matches?.('[data-neonhub-money-cents]')
      ? [root]
      : [...(root?.querySelectorAll?.('[data-neonhub-money-cents]') || [])];

    elements.forEach((element) => {
      const cents = Number(element.dataset.neonhubMoneyCents);
      if (!Number.isFinite(cents)) return;
      const nextText = format(cents);
      if (element.textContent !== nextText) element.textContent = nextText;
    });
  };

  const start = () => {
    window.NeonHubCurrency = {
      currency: sourceCurrency,
      formatAedCents: format,
    };
    applyNativeAmounts(document);
    document.dispatchEvent(new CustomEvent('neonhub:currency-ready', {
      detail: { currency: sourceCurrency },
    }));

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') applyNativeAmounts(mutation.target);
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) applyNativeAmounts(node);
        });
      });
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['data-neonhub-money-cents'],
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
